import { createContext } from 'react';

// Contains template-related data, e.g. uuid, current category key, current screen key
const MagnetContext = createContext();

export default MagnetContext;
